import Vue from 'vue'
//事件总线对象
export const eventBus = new Vue()


// WEBPACK FOOTER //
// ./src/eventbus/index.js